export default class ShowMessage {
  constructor(el) {
    this.el = el;
    // Messages teasers container
    this.selectorItems = this.el.getAttribute('data-messages-list-items');
    this.msgID = document.querySelectorAll(this.selectorItems)[0].id;
    this.selectorView = this.el.getAttribute('data-message-view');
    this.dest = document.querySelector(this.selectorView);
    this.items = $('.c-postbox__message__caret').parents('li');

    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    if (this.items.length) {
      this._getMsg(this.msgID);
      this.items.on('click', item => {
        this._getMsg(item.currentTarget.id);
      });
    }
  }

  /* eslint-disable class-methods-use-this */
  _getMsg(mid) {
    $.post(
      '/message_ajax.php',
      {
        id: mid
      },
      html => {
        this.dest.innerHTML = html;
      }
    );
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/show_message.js